import React from "react";
import { handleEmailClick } from "../TACContents/TAC_10";

const PP_10 = () => {
  return (
    <button
      onClick={handleEmailClick}
      style={{
        color: "#ff2146f0",
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        textDecoration: "underline",
      }}
    >
      info@talentsexplore.com
    </button>
  );
};

export default PP_10;
